import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, ViewChild, } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, } from '@angular/forms';
import { PrimeNGConfig } from 'primeng/api';
import { Calendar } from 'primeng/calendar';
import { Observable, Observer, Subscription } from 'rxjs';

declare var $: any;

export const DATE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DatePickerComponent),
  multi: true,
};

@Component({
  selector: '[datePickerInput]',
  templateUrl: 'date-picker.component.html',
  styleUrls: ['./date-picker.component.css'],
  providers: [DATE_VALUE_ACCESSOR],
})
export class DatePickerComponent implements ControlValueAccessor, OnInit, OnChanges {

  @Input() divClass: string;
  @Input() labelInput: string;
  @Input() mandatory: boolean;
  @Input() placeholder: string;
  @Input() disabled = false;
  @Input() submitPending = false;

  minDate: Date | undefined;
  @Input()
  set dataDal(value: number) {
    this.minDate = value != null ? new Date(value) : undefined;
  }

  maxDate: Date | undefined;
  @Input()
  set dataAl(value: number) {
    this.maxDate = value != null ? new Date(value) : undefined;
  }

  @Input() control: AbstractControl;

  @Output() onValueChange = new EventEmitter();

  _value: number;
  onTouchedCallback: () => void = () => {};
  onChangeCallback: (_: any) => void = () => {};
  @ViewChild('calendar') calendar: Calendar;

  constructor(private primengConfig: PrimeNGConfig) {}

  ngOnInit() {

    this.primengConfig.setTranslation({
      firstDayOfWeek: 1,
      monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gio", "Ve", "Sa"]
    });

  }

  ngOnChanges(): void {}

  onSelect(event): any {
    this._value = event ? event.getTime() : undefined;
    if (this._value) {
      this.onChangeCallback(this._value);
      this.onValueChange.emit(this._value);
    } else {
      this.onChangeCallback(undefined);
      this.onValueChange.emit(undefined);
    }
    setTimeout(() => {
      this.calendar.inputfieldViewChild.nativeElement.focus();
    }, 0);
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  removeSpaces(value: string): string {
    if(!value) return ""
    return value.replace(/\s+/g, '');
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


}
